<template>
  <contents-none
    v-if="tagList.length === 0"
    :none-text="$t('search.no_search_results_A19')"
  ></contents-none>
  <div v-else class="searchTagList">
    <ul>
      <li v-for="(tag, idx) in tagList" :key="idx">
        <router-link :to="`/tagList/${tag.name}`">
          <span class="tagName">#{{ tag.name }}</span>
          <span class="tagNum">
            <strong>{{ tag.productCount }}</strong>
            {{ $t('common.unit.unit_piece_G09') }}
          </span>
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
import ContentsNone from '@/views/base/ContentsNone'

import { mapActions, mapGetters } from 'vuex'

export default {
  //name: "SearchTag",
  components: {
    ContentsNone
  },
  data() {
    return {
      products: []
    }
  },
  computed: {
    ...mapGetters('search', ['tagList'])
  },
  methods: {
    ...mapActions('search', ['searchTag'])
  },
  mounted() {}
}
</script>

<style lang="scss">
.searchTagList {
  background-color: #fff;
  li {
    min-height: 46px;
    border-bottom: 1px solid #d6d6e0;
    a {
      display: table;
      width: 100%;
    }
    span {
      display: table-cell;
      padding: 16px 16px 13px;
      &.tagName {
        word-break: break-all;
      }
      &:last-child {
        text-align: right;
        white-space: nowrap;
      }
    }
  }
}
</style>
